/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TopGuildLeaderLeaderboard } from './TopGuildLeaderLeaderboard';
import {
    TopGuildLeaderLeaderboardFromJSON,
    TopGuildLeaderLeaderboardFromJSONTyped,
    TopGuildLeaderLeaderboardToJSON,
    TopGuildLeaderLeaderboardToJSONTyped,
} from './TopGuildLeaderLeaderboard';

/**
 * 
 * @export
 * @interface GetCurrentGuildTopMembersResponse
 */
export interface GetCurrentGuildTopMembersResponse {
    /**
     * 
     * @type {Array<TopGuildLeaderLeaderboard>}
     * @memberof GetCurrentGuildTopMembersResponse
     */
    members: Array<TopGuildLeaderLeaderboard>;
}

/**
 * Check if a given object implements the GetCurrentGuildTopMembersResponse interface.
 */
export function instanceOfGetCurrentGuildTopMembersResponse(value: object): value is GetCurrentGuildTopMembersResponse {
    if (!('members' in value) || value['members'] === undefined) return false;
    return true;
}

export function GetCurrentGuildTopMembersResponseFromJSON(json: any): GetCurrentGuildTopMembersResponse {
    return GetCurrentGuildTopMembersResponseFromJSONTyped(json, false);
}

export function GetCurrentGuildTopMembersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCurrentGuildTopMembersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'members': ((json['members'] as Array<any>).map(TopGuildLeaderLeaderboardFromJSON)),
    };
}

export function GetCurrentGuildTopMembersResponseToJSON(json: any): GetCurrentGuildTopMembersResponse {
    return GetCurrentGuildTopMembersResponseToJSONTyped(json, false);
}

export function GetCurrentGuildTopMembersResponseToJSONTyped(value?: GetCurrentGuildTopMembersResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'members': ((value['members'] as Array<any>).map(TopGuildLeaderLeaderboardToJSON)),
    };
}

